import { Link } from 'react-router-dom';

export default function SustainabilityCTA() {
  return (
    <section className="py-14 md:py-16 bg-background-50 border-t border-background-200/60">
      <div className="container-page">
        <div className="bg-secondary-50/60 rounded-2xl border border-secondary-200/40 p-8 md:p-12 shadow-sm">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className="text-center lg:text-left">
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-3">
                Want to Build a Greener Cold Chain?
              </h2>
              <p className="text-sm md:text-base text-foreground-500 max-w-lg leading-relaxed">
                Whether you are a warehouse with solar capacity, a transporter switching to bio-CNG, or a processor with a zero-waste line — we want to hear from you.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-4 shrink-0">
              <Link
                to="/contact"
                className="px-8 py-3.5 bg-brand-600 hover:bg-brand-500 text-paper-50 text-sm font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                Talk to Our Sustainability Team
              </Link>
              <Link
                to="/company"
                className="px-8 py-3.5 border border-background-300 hover:border-foreground-400 text-foreground-700 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                Learn About Freshhlock
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}